import api from '@/api'
import {Message} from 'element-ui'
import {setToken, getToken, getButtonsAuth, setButtonsAuth} from '@/utils/auth'
import {setUserInfos, getUserInfos} from '@/utils/userInfos'

export default {
    state: {
        token: getToken(),
        userInfos: getUserInfos(),
        homePage: '',
        // buttonsAuth: getButtonsAuth()
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USERINFOS(state, userInfos) {
            state.userInfos = userInfos;
        },
        SET_HOME_PAGE(state, path) {
            state.homePage = path;
        },
        REMOVE_TOKEN(state) {
            state.token = undefined;
        },
        SET_BUTTONS_AUTH(state, buttonsAuth) {
            state.buttonsAuth = buttonsAuth
        }
    },
    actions: {
        login({commit}, params) {
            // 同步请求
            return new Promise((resolve, reject) => {
                api.service(params).then(res => {
                    if (res.data.code == 0) {
                        let data = res.data.data;
                        let {token, user, tree_data, button} = data;
                        // 缓存token
                        setToken(token);
                        commit('SET_TOKEN', token);
                        // 用户信息
                        setUserInfos(user);
                        commit('SET_USERINFOS', user);
                        // 有权限的按钮
                        // commit('SET_BUTTONS_AUTH', button);
                        // setButtonsAuth(button);

                        Message({
                            type: 'success',
                            message: '登录成功',
                            duration: 2 * 1000
                        });
                    } else {
                        Message({
                            type: 'error',
                            message: res.data.msg,
                            duration: 2 * 1000
                        });
                    }
                    resolve();
                });
            }).catch(err => {
                throw new Error(err);
            });
        }
    },
    getters: {
        homePage: state => state.homePage,
        token: state => state.token,
        userInfos: state => state.userInfos,
        buttonsAuth: state => state.buttonsAuth
    }
}